@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">{{'orgLocation.loading' | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
<form class="locations_addform" id="locations_addform" (ngSubmit)="addNewLocation()" [formGroup]="addShippingLocForm">
  <div class="locations_addhead">{{'orgLocation.shippingcontactuk' | cxTranslate}} <i class="fa-regular fa-circle-question locations_qm locations_tooltip"><span class="locations_tooltiptext">
  {{'orgLocation.shipLoctooltip' | cxTranslate}}</span>
</i>
</div>
<div class="row">

  <div class="col-xs-12 col-md-6 form-group has-feedback">
    <label for="loc_firstname">{{'orgLocform.shipFname' | cxTranslate}}</label>
    <div class="input-group">
      <input class="form-control" id="loc_firstname" name="loc_firstname"  formControlName="loc_firstname"/>
      @if ( addShippingLocForm.get('loc_firstname')?.touched &&  addShippingLocForm.get('loc_firstname')?.invalid) {
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
        </span>
      }
    </div>
    @if (addShippingLocForm.get('loc_firstname') && addShippingLocForm.get('loc_firstname')?.touched && !addShippingLocForm.get('loc_firstname')?.hasError('required') && addShippingLocForm.get('loc_firstname')?.hasError('invalidName')) {
      <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_firstname') && addShippingLocForm.get('loc_firstname')?.touched && addShippingLocForm.get('loc_firstname')?.hasError('required')) {
      <div class="error help-block">{{'orgLocform.errorFirstName' | cxTranslate}}</div>
    }
  </div>
  <div class="col-xs-12 col-md-6 form-group has-feedback">
    <label for="loc_lastname">{{'orgLocform.shipLname' | cxTranslate}}</label>
    <div class="input-group">
      <input class="form-control" id="loc_lastname" name="loc_lastname" formControlName="loc_lastname"/>
      @if ( addShippingLocForm.get('loc_lastname')?.touched && addShippingLocForm.get('loc_lastname')?.invalid) {
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
        </span>
      }
    </div>
    @if (addShippingLocForm.get('loc_lastname')?.touched && !addShippingLocForm.get('loc_lastname')?.hasError('required') && addShippingLocForm.get('loc_lastname')?.hasError('invalidName')) {
      <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_lastname')?.touched && addShippingLocForm.get('loc_lastname')?.hasError('required')) {
      <div class="error help-block">{{'orgLocform.errorLastName' | cxTranslate}}</div>
    }
  </div>


  <div class="col-xs-7 col-md-6 form-group">
    <label for="loc_phone">{{'orgLocform.shipPhn' | cxTranslate}}</label>
    <div class="input-group">
      <input class="form-control" id="loc_phone" maxlength="11" name="loc_phone" [ngClass]="{'is-invalid': addShippingLocForm.get('loc_phone')?.invalid}" formControlName="loc_phone"/>
      @if (addShippingLocForm.get('loc_phone')?.touched &&  addShippingLocForm.get('loc_phone')?.invalid) {
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
        </span>
      }
    </div>
    @if (addShippingLocForm.get('loc_phone')?.touched && addShippingLocForm.get('loc_phone')?.hasError('pattern')) {
      <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_phone')?.touched && addShippingLocForm.get('loc_phone')?.hasError('required')) {
      <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_phone')?.touched && !addShippingLocForm.get('loc_phone')?.hasError('pattern') && addShippingLocForm.get('loc_phone')?.hasError('minlength')) {
      <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_phone')?.touched && !addShippingLocForm.get('loc_phone')?.hasError('pattern') && addShippingLocForm.get('loc_phone')?.hasError('maxlength')) {
      <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
    }
  </div>
  <div class="col-xs-5 col-md-6 form-group">
    <label for="loc_ext">{{'orgLocform.shipExt' | cxTranslate}}</label>
    <div class="input-group">
      <input class="form-control" id="loc_ext" name="loc_ext" [ngClass]="{'is-invalid': addShippingLocForm.get('loc_ext')?.invalid}" formControlName="loc_ext"/>
      @if ( addShippingLocForm.get('loc_ext')?.invalid) {
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
        </span>
      }
    </div>
    @if (addShippingLocForm.get('loc_ext')?.touched && !addShippingLocForm.get('loc_ext')?.hasError('pattern') && addShippingLocForm.get('loc_ext')?.hasError('maxlength')) {
      <div class="error help-block">{{'orgLocform.errorExt' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_ext')?.touched  && addShippingLocForm.get('loc_ext')?.hasError('pattern')) {
      <div class="error help-block">{{'orgLocform.errorValidExt' | cxTranslate}}</div>
    }
  </div>
</div>

<div class="row loc_Email_Row">
    <div class="col-xs-12 col-md-6 form-group email_Field">
      <label for="loc_email">{{'orgLocform.shipemail' | cxTranslate}}</label>
      <div class="input-group">
        <input class="form-control" id="loc_email" name="loc_email" [ngClass]="{'is-invalid': addShippingLocForm.get('loc_email')?.invalid}" formControlName="loc_email"/>
        @if ( addShippingLocForm.get('loc_email')?.touched &&  addShippingLocForm.get('loc_email')?.invalid) {
          <span class="input-group-addon">
            <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
          </span>
        }
      </div>
      @if (addShippingLocForm.get('loc_email')?.touched && addShippingLocForm.get('loc_email')?.hasError('pattern')) {
        <div class="error help-block">{{'orgLocform.errorValidEmail' | cxTranslate}}</div>
      }
      @if (addShippingLocForm.get('loc_email')?.touched && addShippingLocForm.get('loc_email')?.hasError('required')) {
        <div class="error help-block">{{'orgLocform.errorEmail' | cxTranslate}}</div>
      }
    </div>
  </div>
<div class="locations_addhead">{{'orgLocform.shipAddruk' | cxTranslate}}</div>
<div class="row">
  <div class="col-xs-12 col-md-6 form-group"><label for="loc_orgname">{{'orgLocform.shipOrgNameuk' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_orgname" name="loc_orgname" class="form-control" formControlName="loc_orgname"/>
  @if (addShippingLocForm.get('loc_orgname')?.touched && addShippingLocForm.get('loc_orgname')?.invalid) {
    <span class="input-group-addon">
      <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
    </span>
  }
</div>
@if (addShippingLocForm.get('loc_orgname')?.touched && addShippingLocForm.get('loc_orgname')?.hasError('pattern')) {
  <div class="error help-block">{{'orgLocform.errorValidOrgname' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_orgname')?.touched && addShippingLocForm.get('loc_orgname')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorOrgName' | cxTranslate}}</div>
}
</div>

<div class="col-xs-12"><label for="loc_addlp">{{'orgLocform.shipAddrLookup' | cxTranslate}}</label><i class="fa fa-search loc_addsearchicon"></i><input type="text" id="add_AddressLookup" name="add_AddressLookup" formControlName="add_AddressLookup" (focus)="saveScrollPosition()"
(blur)="restoreScrollPosition()"/></div>
<div class="col-xs-12 col-md-6 form-group"><label for="loc_add1">{{'orgLocform.shipAddrLine1' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_add1" name="loc_add1" formControlName="loc_add1" class="form-control" />
@if (addShippingLocForm.get('loc_add1')?.touched && addShippingLocForm.get('loc_add1')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (addShippingLocForm.get('loc_add1')?.touched && addShippingLocForm.get('loc_add1')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorAddr' | cxTranslate}}</div>
}
</div>
<div class="col-xs-12 col-md-6 form-group"><label for="loc_add2">{{'orgLocform.shipAddrLine2' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_add2" name="loc_add2" formControlName="loc_add2" class="form-control"/></div></div>
<div class="col-xs-7 col-md-6 form-group"><label for="loc_city">{{'orgLocform.shipCity' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_city" name="loc_city" formControlName="loc_city" class="form-control"/>
@if (addShippingLocForm.get('loc_city')?.touched && addShippingLocForm.get('loc_city')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (addShippingLocForm.get('loc_city')?.touched && addShippingLocForm.get('loc_city')?.hasError('pattern')) {
  <div class="error help-block">{{'orgLocform.errorvalidCity' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_city')?.touched && addShippingLocForm.get('loc_city')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorCity' | cxTranslate}}</div>
}
</div>

<div class="col-xs-7 col-md-3 form-group"><label for="loc_zip">{{'orgLocform.shipZipuk' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_zip" name="loc_zip" class="form-control" formControlName="loc_zip"/>
@if (addShippingLocForm.get('loc_zip')?.touched && addShippingLocForm.get('loc_zip')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (addShippingLocForm.get('loc_zip')?.touched && addShippingLocForm.get('loc_zip')?.hasError('pattern')) {
  <div class="error help-block">{{'orgLocform.errorzipcodeuk' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_zip')?.touched && addShippingLocForm.get('loc_zip')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorzipcodeuk' | cxTranslate}}</div>
}
</div>
<div class="col-xs-12 col-md-3 form-group"><label for="loc_country">{{'orgLocform.shipCountry' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_country" name="loc_country" class="form-control" formControlName="loc_country">
@if (addShippingLocForm.get('loc_country')?.touched && addShippingLocForm.get('loc_country')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (addShippingLocForm.get('loc_country')?.touched && !addShippingLocForm.get('loc_country')?.hasError('required') && addShippingLocForm.get('loc_country')?.hasError('invalidName')) {
  <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_country')?.touched && addShippingLocForm.get('loc_country')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorcountry' | cxTranslate}}</div>
}

</div>
</div>
<div class="locations_addhead">{{'orgLocation.licInfouk' | cxTranslate}}</div>
<div class="row">
  <div class="col-xs-12 col-md-6 form-group"><label for="loc_licname">{{'orgLocform.shipLicNameuk' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_licname" name="loc_licname" formControlName="loc_licname" class="form-control"/>
  @if (addShippingLocForm.get('loc_licname')?.touched && addShippingLocForm.get('loc_licname')?.invalid) {
    <span class="input-group-addon">
      <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
    </span>
  }
</div>
@if (addShippingLocForm.get('loc_licname')?.touched && !addShippingLocForm.get('loc_licname')?.hasError('required') && addShippingLocForm.get('loc_licname')?.hasError('invalidName')) {
  <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_licname')?.touched && addShippingLocForm.get('loc_licname')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorValidLicName' | cxTranslate}}</div>
}

</div>
<div class="col-xs-12 col-md-6 form-group"><label for="loc_licnum">{{'orgLocform.shipLicNumuk' | cxTranslate}}</label><div class="input-group"><input type="text" id="loc_licnum" maxlength="7" name="loc_licnum" formControlName="loc_licnum" class="form-control"/>
@if (addShippingLocForm.get('loc_licnum')?.touched && addShippingLocForm.get('loc_licnum')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (addShippingLocForm.get('loc_licnum')?.touched && !addShippingLocForm.get('loc_licnum')?.hasError('required') && addShippingLocForm.get('loc_licnum')?.hasError('invalidLicNum')) {
  <div class="error help-block">{{'orgLocform.errorValidLicNumuk' | cxTranslate}}</div>
}
@if (addShippingLocForm.get('loc_licnum')?.touched && addShippingLocForm.get('loc_licnum')?.hasError('required') || addShippingLocForm.get('loc_licnum')?.hasError('pattern')) {
  <div class="error help-block">{{'orgLocform.errorValidLicNumuk' | cxTranslate}}</div>
}

</div>
<div class="orgLoc_nhsCode">
  <div class="col-xs-12 col-md-6 form-group"><label for="loc_nhsnumb">{{'orgLocform.nhsCodeuk' | cxTranslate}}<sup></sup></label>
    <div class="input-group"><input type="text" id="loc_nhscode" formControlName="loc_nhsnumb" name="loc_nhsnumb" class="form-control">
      @if (addShippingLocForm.get('loc_nhsnumb')?.touched && addShippingLocForm.get('loc_nhsnumb')?.invalid) {
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
        </span>
      }
    </div>
    @if (addShippingLocForm.get('loc_nhsnumb')?.touched && addShippingLocForm.get('loc_nhsnumb')?.hasError('required')) {
      <div class="error help-block">{{'orgLocform.orgnhsrequired' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_nhsnumb')?.touched && addShippingLocForm.get('loc_nhsnumb')?.value && addShippingLocForm.get('loc_nhsnumb')?.hasError('nhserror1')) {
      <div class="error help-block">{{'orgLocform.errorNhsGpadd' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_nhsnumb')?.touched && addShippingLocForm.get('loc_nhsnumb')?.value && addShippingLocForm.get('loc_nhsnumb')?.hasError('nhserror2')) {
      <div class="error help-block">{{'orgLocform.errorNhsPharmaadd' | cxTranslate}}</div>
    }
    @if (addShippingLocForm.get('loc_nhsnumb')?.touched && addShippingLocForm.get('loc_nhsnumb')?.value && addShippingLocForm.get('loc_nhsnumb')?.hasError('nhserror3')) {
      <div class="error help-block">{{'orgLocform.errorNhsAlladd' | cxTranslate}}</div>
    }
  </div>

  <div class="col-xs-12 col-md-6 orgLoc_nhsCodeLinks">
    <div class="ext_Pop_Link" (click)="openNhsExtPopup()"><span class="orgLoc_Ext_Pop">How to find your NHS code</span><svg xmlns="http://www.w3.org/2000/svg"
        width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M15.2385 16.08C15.128 16.183 15.0393 16.3072 14.9778 16.4452C14.9163 16.5832 14.8833 16.7322 14.8806 16.8832C14.8779 17.0343 14.9057 17.1843 14.9623 17.3244C15.0189 17.4645 15.1031 17.5918 15.2099 17.6986C15.3168 17.8054 15.444 17.8896 15.5841 17.9462C15.7242 18.0028 15.8742 18.0306 16.0253 18.0279C16.1763 18.0253 16.3253 17.9922 16.4633 17.9307C16.6013 17.8692 16.7255 17.7806 16.8285 17.67L21.7035 12.795L22.5 12L21.705 11.205L16.83 6.33003C16.6179 6.125 16.3338 6.01147 16.0388 6.01389C15.7438 6.01632 15.4616 6.1345 15.2529 6.34299C15.0443 6.55147 14.9258 6.83358 14.9231 7.12855C14.9204 7.42352 15.0337 7.70776 15.2385 7.92003L18.1935 10.875H2.625C2.32663 10.875 2.04048 10.9936 1.8295 11.2045C1.61853 11.4155 1.5 11.7017 1.5 12C1.5 12.2984 1.61853 12.5845 1.8295 12.7955C2.04048 13.0065 2.32663 13.125 2.625 13.125H18.1935L15.2385 16.08Z"
          fill="#2A3237" />
      </svg>
    </div>
  </div>
</div>
</div>

<div class="locations_addlocsection">
  <button type="submit" class="locations_addloc">{{'orgLocation.reqLocLabel' | cxTranslate}}</button>
</div>

</form>
<!--Thank you Modal-->
@if (showThankyouModal) {
  <div>
    <div id="locations_tymodal" class="modal fade in show" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body row">
            <h4 class="modal-title locations_tyheader col-xs-9">Thank You for Requesting a New Location</h4>
            <div class="col-xs-3"><span class="locations_closebtn" data-dismiss="modal" (click)="onClose()">&times;</span></div>
            <p class="locations_tysubheader col-xs-12">We will review and verify your new location information, within 5 business days.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!--Thank you modal end-->
